import { StyledText } from '@app/collections/dynamic-form/elements'
import { Button, Col, Description, DescriptionItem, If, Modal, Notification, Row, Spacer, Text } from '@app/components'
import { IStore } from '@app/redux'
import { auth, Axios, createTweet, errorHandler } from '@app/services'
import { OffSummaryProps3 } from '@app/types'
import { toCurrency } from '@app/utils'
import { Button as AntButton } from 'antd'
import { AddDiscountDrawer } from 'collections/buy-and-sell/drawers'
import useDeposit from 'libs/services/hooks/useDeposit'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useAccount, useChainId } from 'wagmi'

import { BurnPendingModal } from '../pending'
import { StyledCard } from './elements'

export const OffSummary: React.FC<OffSummaryProps3> = ({
  purchaseData: { pay, receive },
  fee,
  //balance,
  coastBalance,
  //fetchAccounts,
  //setBurnLoading,
}) => {
  const { user } = useSelector((state: IStore) => state)
  const [, setLoading] = useState(false)
  const [discountDrawerOpen, setDiscountDrawerOpen] = useState(false)
  //const [signed, setSigned] = useState({ wallet: '', signature: '' })
  const [percent, setPercent] = useState(0)
  const [showPopup, setShowPopup] = useState(false)
  const [popupDismissed, setPopupDismissed] = useState(false)
  const { address } = useAccount()
  const chainId = useChainId()
  //const { data: signMessageData, error, isPending, signMessage, variables } = useSignMessage()
  const burn = useDeposit(pay.amount, actual_shit, pay.type)

  /*const [achHeld, setAchHeld] = useState(0)
  const [cardHeld, setCardHeld] = useState(0)
  const [old_bal, setOldBal] = useState(0)*/
  const router = useRouter()

  /*useEffect(() => {
    setBurnLoading(burn.state === 'loading')
  }, [burn.state])*/

  async function actual_shit(loadingHash) {
    if (loadingHash) {
      const data = {
        loading: true,
        amount: pay.amount,
        entityId: user.selectedEntityName ? user.selectedEntityIdentityId : null,
        fee: fee,
        wallet: address,
        hash: loadingHash,
        //secret: signed.signature,
        token: pay.type,
        deposit: true,
      }
      const authorization = await auth.currentUser.getIdToken()
      const headers = {
        Authorization: authorization,
      }
      await Axios.post('/api/north-one/burn', data, { headers })
      return
    }
    if (burn.hash == 0 || !burn.hash) {
      pay.setAmount(0)
      receive.setAmount(0)
      setLoading(false)
    } else {
      if (pay.amount >= 1000) {
        await createTweet(auth, { type: 'burn', amount: pay.amount, address: address, token: pay.type })
      }

      setPercent(100)
      setPercent(0)

      //fetchAccounts()
      pay.setAmount(0)
      receive.setAmount(0)
      setLoading(false)

      //Push user to transactions page
      router.push('/transactions')
    }
  }

  /*useEffect(() => {
    (async () => {
      if (variables?.message && signMessageData) {
        // eslint-disable-next-line no-console
        //await addWallet(user.uid, address, signMessageData)
        const data = {
          address: address,
          signMessageData: signMessageData,
        }
        const authorization = await auth.currentUser.getIdToken()
        const headers = {
          Authorization: authorization,
        }
        await Axios.post('/api/coast/burn-wallet', data, { headers })
        getSigned(user.uid, address)
      } else if (error) {
        // eslint-disable-next-line no-console
        console.error('Error signing message:', error)
      }
    })()
  }, [signMessageData, variables?.message])*/

  /*useEffect(() => {
    getSigned(user.uid, address)
  }, [address, signMessageData, variables])*/

  /*const getSigned = async (uid: string, account: string) => {
    if (address != undefined) {
      const signedWallets = await getWallets(uid)

      const numWallets = signedWallets.length

      for (let i = 0; i < numWallets; i++) {
        if (signedWallets[i].Wallet == address) {
          setSigned({ wallet: account, signature: signedWallets[i].Nickname })
          return
        }
      }

      setSigned({ wallet: '', signature: '' })
    } else {
      setSigned({ wallet: '', signature: '' })
    }
  }*/

  /*const addSigned = async () => {
    if (address != undefined) {
      const dataToSign = 'Approve Wallet for CST burning'
      // const dataHex = Web3.utils.utf8ToHex(dataToSign)

      signMessage({ account: address, message: dataToSign })
    } else {
      Notification({ message: 'Connect Wallet', type: 'error' })
    }
  }*/

  const transfer = async () => {
    if (pay.type === 'CST' && !popupDismissed) {
      setShowPopup(true)
      return
    }
    try {
      if (address != undefined) {
        setLoading(true)
        setPercent(25)
        await burn.write()
      }
    } catch (error) {
      setPercent(0)
      setLoading(false)
      Notification({ message: error.response.data, type: 'error' })
      errorHandler.report`Failed to create transaction: ${error}`
    }
  }

  const handlePopupSwap = () => {
    router.push('/swap')
  }

  const handlePopupContinue = () => {
    setShowPopup(false)
    setPopupDismissed(true)
  }

  const topLabelItemStyle: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: 'bold',
  }

  const topDescriptionItemStyle: React.CSSProperties = {
    justifyContent: 'end',
    fontSize: '18px',
  }

  const descriptionItemStyle: React.CSSProperties = {
    justifyContent: 'end',
  }

  const labelFeeBoldItemStyle: React.CSSProperties = {
    marginLeft: '16px',
    fontSize: '14px',
  }

  const descFeeBoldItemStyle: React.CSSProperties = {
    justifyContent: 'end',
    fontSize: '14px',
  }

  const summaryDesc = <Text style={{ fontSize: '24px' }}>Deposit Summary</Text>

  const feeLink = (
    <Button
      type="link"
      style={{ padding: 0, fontSize: '14px' }}
      size="small"
      onClick={() => setDiscountDrawerOpen(true)}
    >
      Fee ({fee}%)
    </Button>
  )

  return (
    <>
      <StyledCard>
        <Description title={summaryDesc} column={1}>
          <DescriptionItem
            label={'Total Deposit'}
            labelStyle={topLabelItemStyle}
            contentStyle={topDescriptionItemStyle}
          >
            {`${toCurrency(pay.amount, false)} ${pay.type}`}
          </DescriptionItem>
          <DescriptionItem
            label={'Total Recieved'}
            labelStyle={topLabelItemStyle}
            contentStyle={topDescriptionItemStyle}
          >
            {`${toCurrency(receive.amount, true)} ${receive.type}`}
          </DescriptionItem>
          <DescriptionItem label={'Total Fees'} contentStyle={descriptionItemStyle}>
            {`${toCurrency(pay.amount - receive.amount, true)} ${receive.type}`}
          </DescriptionItem>
          {chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? (
            <DescriptionItem label={feeLink} labelStyle={labelFeeBoldItemStyle} contentStyle={descFeeBoldItemStyle}>
              {`${toCurrency(pay.amount - receive.amount, true)} ${pay.type}`}
            </DescriptionItem>
          ) : (
            <Text>Connect to Ethereum to view Deposit fee</Text>
          )}

          <DescriptionItem label={'Wallet'} contentStyle={descriptionItemStyle}>
            {address != undefined ? address.slice(0, 4) + '...' + address.slice(-4) : 'Connect Wallet'}
          </DescriptionItem>
          <DescriptionItem label={'New Wallet Balance'} contentStyle={descriptionItemStyle}>
            {chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) && address != undefined ? (
              <>{`${toCurrency(coastBalance - pay.amount, false)} ${pay.type}`}</>
            ) : (
              'Connect Wallet'
            )}
          </DescriptionItem>
        </Description>
        <Spacer />
        <Row>
          {/*<Col span={12}>
            <Button
              block
              disabled={
                address == undefined ||
                chainId != parseInt(process.env.NEXT_PUBLIC_PULSECHAIN) ||
                isPending ||
                signed.wallet != ''
              }
              onClick={() => addSigned()}
              loading={isPending}
            >
              {signed.wallet == '' ? 'Approve' : 'Approve'}
            </Button>
          </Col>*/}
          <Col span={24}>
            <Button
              block
              disabled={
                !pay.amount ||
                !(pay.amount <= coastBalance) ||
                //signed.wallet == '' ||
                //isPending ||
                //signed.wallet != address ||
                pay.amount - receive.amount <= 0 ||
                burn.state !== 'enabled'
              }
              onClick={transfer}
              loading={burn.state === 'loading'}
            >
              Deposit {`${toCurrency(pay.amount, false)} ${pay.type}`}
            </Button>
          </Col>
        </Row>
        <If condition={chainId != parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN)}>
          <>
            <Spacer value={20} />
            <StyledText>Connect to Ethereum to Deposit {pay.type}</StyledText>
          </>
        </If>
      </StyledCard>
      <AddDiscountDrawer open={discountDrawerOpen} toggleOpen={() => setDiscountDrawerOpen(!discountDrawerOpen)} />

      <BurnPendingModal
        toggleOpen={() => {
          return true
        }}
        percent={percent}
        setPercent={setPercent}
      />

      <Modal
        title={
          <Row style={{ textAlign: 'center' }}>
            <Col span={24}>
              <Text>Wait! Did you know you can save... </Text>
            </Col>
          </Row>
        }
        open={showPopup}
        onCancel={() => setShowPopup(false)}
        footer={null}
        centered
        width={650}
      >
        <Row gutter={[10, 10]} style={{ textAlign: 'center' }}>
          <Col span={24}>
            <Text style={{ fontSize: '3em' }}>${toCurrency((pay.amount - receive.amount) * 0.75, false)}</Text>
            <br />
            <Text>by burning USDC, USDT, or DAI</Text>
          </Col>
          <Col span={12}>
            <Button block onClick={() => handlePopupSwap()}>
              Swap $CST
            </Button>
          </Col>
          <Col span={12}>
            <AntButton block onClick={() => handlePopupContinue()}>
              Continue
            </AntButton>
          </Col>
        </Row>
      </Modal>
    </>
  )
}
